import { MethodologyModal } from '../detail/voltage/MethodologyModal'
import { AboutPage } from './AboutPage'
import { useOverlayHashSync, useOverlayStore } from './overlayStore'

/**
 * Renders whichever full-screen surface is open, and keeps the fragment in step.
 *
 * Mounted once, as page chrome. It deliberately does not live inside the
 * footer, which is where it started: the methodology modal is opened from a
 * voltage badge deep inside the detail panel, and hanging that dialog off an
 * unrelated region means it works only by accident of what happens to be
 * mounted beside it. A visitor on a phone with no site selected would still
 * expect the badge's link to open something.
 */
export const OverlayHost = () => {
  const overlay = useOverlayStore((state) => state.overlay)

  useOverlayHashSync()

  if (overlay === 'about') return <AboutPage />
  if (overlay === 'methodology') return <MethodologyModal />
  return null
}
